<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <!-- <a-col :md="6" :sm="24" v-if="userType==0 &&!tenantFirmId">
              <a-form-item label="企业品牌">
                <a-select
                  show-search
                  v-model="queryParam.upperId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="24">
              <a-form-item label="订单编号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="物流单号">
                <a-input v-model="queryParam.dvyFlowId" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col> -->

            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="收件人">
                <a-input v-model="queryParam.receiverName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="收件人电话">
                <a-input v-model="queryParam.receiverMobile" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="收件人地址">
                <a-input v-model="queryParam.receiverAddress" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="订单状态">
                <a-select
                  show-search
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="1">待付款</a-select-option>
                  <a-select-option :key="2">待审核</a-select-option>
                  <a-select-option :key="3">待发货</a-select-option>
                  <a-select-option :key="4">待收货</a-select-option>
                  <a-select-option :key="6">成功</a-select-option>
                  <a-select-option :key="7">失败</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="配送类型">
                <a-select
                  show-search
                  v-model="queryParam.dvyType"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="1">快递</a-select-option>
                  <a-select-option :key="2">自提</a-select-option>
                  <a-select-option :key="3">无需快递</a-select-option>
                  <a-select-option :key="4">线下配送</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <template v-if="isOperate">
          <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['upkeep:script:add']">
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['upkeep:script:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['upkeep:script:remove']">
            <a-icon type="delete" />删除
          </a-button>
        </template> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <!-- 批量导入 -->
      <!-- <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd> -->
      <Examine ref="Examine" @ok="getList"></Examine>
      <orderDetail ref="orderDetail"></orderDetail>
      <print ref="print"></print>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="orderId"
        :columns="columns"
        ref="table"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :expandedRowKeys="expandedRowKeys"
        @expand="onExpand"
      >
        <a-table
          slot="expandedRowRender"
          rowKey="orderItemId"
          size="middle"
          :columns="innerColumns"
          :data-source="innerList"
          :pagination="false"
          class="inner-no-scroll"
        >
        </a-table>
        <span slot="status" slot-scope="text, record">
          {{
            record.status == 1
              ? '待付款'
              : record.status == 2
              ? '待审核 '
              : record.status == 3
              ? '待发货'
              : record.status == 4
              ? '待收货 '
              : record.status == 6
              ? '成功 '
              : '失败'
          }}
        </span>
        <span slot="scriptExplanation" slot-scope="text, record">
          <!-- <a  > 查看 </a> -->
          <!-- <a-tooltip :title="record.scriptExplanation" title-type="html">
            <a> 查看 </a>
          </a-tooltip> -->
          <a-tooltip>
            <template #title>
              <div v-html="record.scriptExplanation"></div>
              <!-- 富文本支持 -->
            </template>
            <a> 查看 </a>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="handleDelete(record)"
            v-hasPermi="['19604592ffb37467a42d15527752cb02d:0:d']"
            v-if="record.status == 1"
          >
            取消订单
          </a>
          <a-divider v-if="record.status == 1" type="vertical" v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']" />
          <a-dropdown v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']">
                <a @click="$refs.orderDetail.init(record, 1)" v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']">
                  详情
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']">
                <a @click="$refs.print.init(record, 1)" v-hasPermi="['19604592ffb37467a42d15527752cb02q:0:q']">
                  打印
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['604592ffb37467a42d15527752cb02c:0:r']" v-if="record.status == 1">
                <a @click="$refs.Examine.init(record, 2)" v-hasPermi="['604592ffb37467a42d15527752cb02c:0:r']">
                  订单备注
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['19604592ffb37467a42d15527752cb02c:0:c']" v-if="record.status == 2">
                <a @click="$refs.Examine.init(record, 1)" v-hasPermi="['19604592ffb37467a42d15527752cb02c:0:c']">
                  审核
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['19604592ffb37467a42d15527752cb02d:0:d']" v-if="record.status == 3">
                <a @click="$refs.Examine.init(record, 3)" v-hasPermi="['19604592ffb37467a42d15527752cb02d:0:d']">
                  发货
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <!-- <a-table
          slot="expandedRowRender"
          slot-scope="record"
          :columns="innerColumns"
          :pagination="false"
          :data-source="record.taOrderItemSons"
        >
          <span slot="operation" slot-scope="text, records">
            <a @click="$refs.attributeForm.init(record.id, records.id)">属性 </a>
          </span>
        </a-table> -->
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, cancelObj, statusObj } from '@/api/declaration/declarationOrder'
import CreateForm from './modules/CreateForm'
import Examine from './modules/examine.vue'
import orderDetail from './modules/orderDetail.vue'
import print from './modules/print.vue'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
// import UploadAdd from './modules/uploadAdd'
// import Parameter from '../../pressure/parameter'
// import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
    Examine,
    orderDetail,
    print,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      expandedRowKeys: [],
      innerList: [],
      innerColumns: [
        { title: '商品名称', dataIndex: 'prodName', width: 160, key: 'prodName', align: 'center' },
        { title: '价格', dataIndex: 'price', width: 100, align: 'center' },
        { title: '个数', dataIndex: 'prodCount', width: 100, align: 'center' },
        { title: '总金额', dataIndex: 'productTotalAmount', width: 100, align: 'center' },
        { title: 'sku名称', dataIndex: 'skuName', width: 100, align: 'center' },
        { title: '排序号', dataIndex: 'sort', width: 100, align: 'center' },
      ],
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        keyword: undefined,
        periodType: undefined,
        searchCount: undefined,
      },
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          align: 'center',
          // fixed: 'left',
          width: '12%',
        },
        {
          title: '收件人',
          dataIndex: 'receiverName',
          width: '6%',
          align: 'center',
        },
        {
          title: '收件人电话',
          dataIndex: 'receiverMobile',
          width: '7%',
          align: 'center',
        },
        {
          title: '用户手机号',
          dataIndex: 'userPhone',
          width: '7%',
          align: 'center',
        },

        {
          title: '商品总数',
          dataIndex: 'productNums',
          width: '7%',
          align: 'center',
        },
        {
          title: '优惠金额',
          dataIndex: 'platformAmount',
          width: '7%',
          align: 'center',
        },
        {
          title: '优惠总额',
          dataIndex: 'reduceAmount',
          width: '7%',
          align: 'center',
        },
        {
          title: '总值',
          width: '7%',
          dataIndex: 'total',
          align: 'center',
        },
        // {
        //   title: '话术说明',
        //   dataIndex: 'scriptExplanation',
        //   scopedSlots: { customRender: 'scriptExplanation' },
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '订单状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
                   width: '7%',
          ellipsis: true,
          align: 'center',
        },

        // {
        //   title: '排序',
        //   dataIndex: 'sort',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center',
        // },
        //   {
        //   title: '发货时间',
        //   dataIndex: 'dvyTime',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '完成时间',
          dataIndex: 'finallyTime',
          // ellipsis: true,
          width: '7%',
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '7%',
          // ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
                width: '15%',
          // fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    this.queryParam.tenantFirmId = this.tenantFirmId
    this.queryParam.tenantId = this.tenantId
    this.getList()
    if (!this.tenantFirmId) {
      // this.getQi()
    }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    onExpand(expanded, record) {
      const key = record.orderId // 与 rowKey 保持一致
      if (expanded) {
        this.expandedRowKeys = [...this.expandedRowKeys, key]
        this.innerList = record.taOrderItemSons || []
      } else {
        this.expandedRowKeys = this.expandedRowKeys.filter((k) => k !== key)
        this.innerList = []
      }

      // 1. 複製一份新陣列
      const newCols = [...this.columns]
      // 2. 改這一份
      newCols[11] = { ...newCols[11], fixed: expanded ? false : 'right' }
      // 3. 整包換掉，觸發重新渲染
      this.columns = newCols
    },
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    // 状态修改
    handleStatusType(row) {
      // row.status = row.status == '0' ? '1' : '0'
      statusObj({ id: row.id })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(function () {
          row.status = row.status == '0' ? '1' : '0'
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {},
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.orderId]
      // } else {
      //   ids = this.ids
      // }
      this.$confirm({
        title: '是否确认取消此订单?',
        onOk() {
          return cancelObj({ orderId: row.orderId }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('取消成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
<style>
/* 让展开部分撑满且不出现横向滚动条 */
.inner-no-scroll {
  width: 100%;
  overflow: hidden;
}
.inner-no-scroll .ant-table-content {
  overflow-x: visible !important;
}

.ant-table-expanded-row {
  height: auto !important;
  transition: height 0.2s ease;
}
</style>
